import React, { memo, useMemo } from 'react'

import { func, shape } from 'prop-types'

import { imageShape } from 'Pods/LazyLoaded/ImageGalleryPanel/imageShape'
import { getSimilarImages } from 'Pods/LazyLoaded/ImageGalleryPanel/Utils/mockImages'

import { NOOP } from 'Utils/stableDefaults'

import Creator from './Components/Creator/Creator'
import GenerationSettings from './Components/GenerationSettings/GenerationSettings'
import Prompt from './Components/Prompt/Prompt'
import SimilarImages from './Components/SimilarImages/SimilarImages'

function Details({ image, onSelect = NOOP }) {
  const similarImages = useMemo(() => getSimilarImages(image), [image])

  return (
    <div className="image-gallery-modal__details">
      <div className="image-gallery-modal__summary">
        <Creator user={image.user} createdAt={image.createdAt} />
        <Prompt text={image.prompt} />
        <GenerationSettings settings={image.settings} />
      </div>
      <SimilarImages images={similarImages} onSelect={onSelect} />
    </div>
  )
}

Details.propTypes = {
  image: shape(imageShape).isRequired,
  onSelect: func,
}

export default memo(Details)
